import { Cell } from './Cell'

export const EmptyRow = () => {
  return (
    <div className="flex justify-center mb-2">
      <div className="w-80 h-8 border-solid border-2 flex items-center justify-center mx-0.5 text-lg font-bold rounded border-slate-600"/>
    </div>
  )
}
